module.exports = __webpack_public_path__ + "static/media/my_project_caret_down.877610ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/Sidebar/my_project_caret_down.svg
// module id = 1428
// module chunks = 2